import React, { Suspense } from 'react';
// import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';
// import './assets/scss/style.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import Loader from './layouts/loader/Loader';
import PdfView from './views/TcIssueMasterDetail/PdfView';
import { Provider } from 'react-redux';
import { store } from './reducetool/store';
import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

window.onerror = function (msg, url, line, col, error) {
  console.error('Global error:', { msg, url, line, col, error });
};

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('Service Worker registered:', registration);
      })
      .catch((err) => {
        console.error('Service Worker registration failed:', err);
      });
  });
}

root.render(
  <Provider store={store}>
    <HelmetProvider>
      <Suspense fallback={<Loader />}>
        <BrowserRouter>
          {/* <PdfView admission_Data={null} tc_Issue_Master_Data={null}> */}
          <App />a
          {/* </PdfView> */}
        </BrowserRouter>
      </Suspense>
    </HelmetProvider>
  </Provider>

  // document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
